// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#search-box.w-100{background:transparent}.recent-result{z-index:1}.recent-result span{color:#00cda7}.recent-result small{background:#fff;border-radius:20px;padding:3px 10px;margin-right:10px;cursor:pointer;display:inline-block;margin-bottom:5px}.search-box-autocomplete{position:relative;z-index:9}", ""]);
// Exports
module.exports = exports;
